import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ListStyle = styled.ol.attrs(
  ({ $letterSpacing, $rowSpacing, $linkColor }) => ({
    $letterSpacing: $letterSpacing || "",
    $rowSpacing: $rowSpacing || "",
    $linkColor: $linkColor || "",
  })
)`
  letter-spacing: ${({ $letterSpacing }) => $letterSpacing};
  line-height: ${({ $rowSpacing }) => $rowSpacing};
  a {
    color: ${({ $linkColor }) => $linkColor};
  }
`;
export default function List({ letterSpacing, rowSpacing, values, linkColor }) {
  return (
    <ListStyle
      $letterSpacing={letterSpacing}
      $rowSpacing={rowSpacing}
      dangerouslySetInnerHTML={{ __html: values }}
      $linkColor={linkColor}
    />
  );
}

List.propTypes = {
  letterSpacing: PropTypes.string,
  rowSpacing: PropTypes.string,
  values: PropTypes.string,
  linkColor: PropTypes.string,
};
